/* Messe-Shop24 – Anbindung BSS B2B (Händlerpreise) an nachgeladene Inhalte.
   Ersetzt Eingriffe in Canopy-JS aus 6.3.1 live (BSS-Support, 10.03.2025):
   1. assets/main.js, ProductRecommendations.init(): nach dem Nachladen der Empfehlungen
      BSS „LoadedLazyProduct“ melden.
   2. assets/quick-add.js, handleVariantChange(): BSS bei Variantenwechsel im Quick-Add benachrichtigen.
   3. assets/quick-add.js, open(): Event „bss_b2b:QuickviewLoaded“, wenn der Quick-Add-Inhalt geladen ist.
   Änderung: Canopy-Dateien bleiben Original; Anschluss über MutationObserver bzw. Canopy-Event
   on:variant:change. Guard window.BSS_B2B (live warf `if (BSS_B2B)` ohne App einen ReferenceError).
   Eigene Datei: wird von Canopy-Updates nicht überschrieben. */
(function () {
  if (window.msBssB2b) return;
  window.msBssB2b = true;

  /* 1 – Produktempfehlungen */
  async function lazyProdukteMelden() {
    const B = window.BSS_B2B;
    if (!B) return;
    const res = await B.storage.productStorage.load();
    if (res && (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size)) {
      B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', { ...res });
    }
  }
  const beobachtet = new WeakSet();
  function empfehlungenBeobachten() {
    document.querySelectorAll('product-recommendations').forEach((el) => {
      if (beobachtet.has(el)) return;
      beobachtet.add(el);
      new MutationObserver(() => { lazyProdukteMelden(); }).observe(el, { childList: true });
    });
  }

  /* 2 – Variantenwechsel im Quick-Add */
  document.addEventListener('on:variant:change', (evt) => {
    const B = window.BSS_B2B;
    if (!B || !evt.target.closest || !evt.target.closest('quick-add-drawer')) return;
    const productForm = document.querySelector('[bss-b2b-quickview-product-form]');
    B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
  });

  /* 3 – Quick-Add-Inhalt geladen */
  function quickAddBeobachten() {
    const ziel = document.querySelector('quick-add-drawer .js-product-details');
    if (!ziel || beobachtet.has(ziel)) return;
    beobachtet.add(ziel);
    new MutationObserver(() => {
      if (window.BSS_B2B) document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
    }).observe(ziel, { childList: true });
  }

  /* 4 – Zwischensumme inkl. Zusatzleistungen (Feedback 04.10.2026)
     BSS berechnet die Zwischensumme („… * mit MwSt.“) aus eigenen Daten und lässt Unterpositionen
     (Zusatzleistungen, nested cart lines) weg. Über den BSS-Filter custom:cart/tdSubTotal werden die
     Summen aus snippets/ms-cart-zusatz-summe.liquid addiert. Sicherung: nur wenn BSS die
     Unterpositionen nachweislich nicht mitzählt (BSS-Netto + Zusatz ≤ Shopify-Warenkorbsumme). */
  window.bssB2BHooks = window.bssB2BHooks || { actions: {}, filters: {} };
  window.bssB2BHooks.filters = window.bssB2BHooks.filters || {};
  const bisherigerFilter = window.bssB2BHooks.filters['custom:cart/tdSubTotal'];
  window.bssB2BHooks.filters['custom:cart/tdSubTotal'] = function (html, ctx) {
    if (typeof bisherigerFilter === 'function') html = bisherigerFilter(html, ctx);
    try {
      const daten = document.querySelector('[data-ms-zusatz-summe]');
      const netto = daten ? Number(daten.dataset.msZusatzSumme) : 0;
      if (!netto) return html;
      const brutto = Number(daten.dataset.msZusatzBrutto) || Math.round(netto * 1.19);
      const gesamt = Number(daten.dataset.msCartTotal) || 0;
      const B = window.BSS_B2B;
      const td = B && B.shopData && B.shopData.cart && B.shopData.cart.bss_b2b_total_priceTD;
      if (!td || typeof B.formatMoney !== 'function') return html;
      if (gesamt && td.subtotalNoVat + netto > gesamt + 1) return html; // BSS zählt sie bereits
      const alt1 = B.formatMoney(td.subtotalNoVat);
      const alt2 = B.formatMoney(td.subtotalHasVat);
      return html.split(alt1).join(B.formatMoney(td.subtotalNoVat + netto))
                 .split(alt2).join(B.formatMoney(td.subtotalHasVat + brutto));
    } catch (e) {
      return html;
    }
  };

  function init() { empfehlungenBeobachten(); quickAddBeobachten(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
